import React from "react"
import Imgix from "react-imgix"
import Layout from "../components/layout"
import SEO from "../components/seo"
import OverviewSellBlock from "../components/overview-sell-block"
import Packages from "../components/packages"
import SubheaderFinance from "../components/subheader-finance"
import GenericHero from "../components/generic-hero"
import SubheaderCovid from "../components/subheader-covid"

// foundation
import touchscreen from "../images/overview/touchscreen.svg"
import sensors from "../images/overview/sensors.svg"
import windowSensors from "../images/overview/window-sensors.svg"


// control
import remote from "../images/overview/remote.svg"
import alerts from "../images/overview/alerts.svg"
import codes from "../images/overview/codes.svg"

// foundation
import schedule from "../images/overview/schedule.svg"
import location from "../images/overview/location.svg"
import energy from "../images/overview/energy.svg"
import CustomHero from "../components/custom-hero"

const OverviewPage = () => (
  <Layout className="overview" headerSeparator>
    <SEO title="Smart Home Security App for Android and iOS" />
    <SubheaderFinance
        title="Packages from "
        price="$16.99/mo"
        link="http://d2eb8hz387zjm2.cloudfront.net/popular/#packages"
    />

    <CustomHero
      image="https://brightsuite.imgix.net/overview/bs-overview.png"
      title={"Brightsuite Overview"}
      children={"Configuring Things Your Way is Brightly Satisfying"}
      body={"Home security and automation are changing at a rapid pace, and there are many options to consider. We created BrightSuite to simplify things by offering best-in-class products that can be customized to fit how you live."}
    >
    </CustomHero>

    <div className="generic-hero__features">
      <div className="feature">
        <img
          className="feature__icon"
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiM0OTRFNTIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE3IDRoMnYxNmgtMlY0ek01IDE0aDJ2Nkg1di02em02LTVoMnYxMWgtMlY5eiIvPgogICAgPC9nPgo8L3N2Zz4K"
          alt="Reliable Network"
        />
        <div className="feature__desc t2">Reliable Network</div>
      </div>
      <div className="feature">
        <img
          className="feature__icon"
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDE2IDIwIj4KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM0OTRFNTIiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTggMS43NDljLS44MzIuOTc1LTEuODgzIDEuNjk5LTMuMDk3IDIuMTk2LTEuMzI1LjU0My0yLjY4Ljc3LTMuOTAzLjc5NnY3LjgyYzAgMS4xMDguNTYgMi4xMzcgMS40ODQgMi43MjdMOCAxOC44MTNsNS41MTYtMy41MjVBMy4yMzMgMy4yMzMgMCAwIDAgMTUgMTIuNTZWNC43NGExMC45NjQgMTAuOTY0IDAgMCAxLTMuOTAzLS43OTZDOS44ODMgMy40NDggOC44MzIgMi43MjQgOCAxLjc1eiIvPgo8L3N2Zz4K"
          alt="Professional Monitoring"
        />
        <div className="feature__desc t2">24/7 Professional Monitoring</div>
      </div>
      <div className="feature">
        <img
          className="feature__icon"
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDE4IDIwIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggc3Ryb2tlPSIjNDk0RTUyIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik05IDEuMTQ0TDEgNS41ODh2OC44MjRsOCA0LjQ0NCA4LTQuNDQ0VjUuNTg4TDkgMS4xNDR6Ii8+CiAgICA8Y2lyY2xlIGN4PSI5IiBjeT0iMTAiIHI9IjIiIGZpbGw9IiM0OTRFNTIiLz4KICAgIDxjaXJjbGUgY3g9IjkiIGN5PSIxMCIgcj0iMiIgZmlsbD0iIzQ5NEU1MiIvPgogIDwvZz4KPC9zdmc+Cg=="
          alt="Installation Your Way"
        />
        <div className="feature__desc t2">Installation Your Way</div>
      </div>

      <div className="feature">
        <img
          className="feature__icon"
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDE0IDIwIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTIuODA1IDE4LjY2YTEuNjE1IDEuNjE1IDAgMCAxLTEuNjE1LTEuNjE1VjIuODA1YzAtLjg5Mi43MjMtMS42MTUgMS42MTUtMS42MTVoNy43NjFjLjg5MiAwIDEuNjE1LjcyMyAxLjYxNSAxLjYxNXYxNC4yNGMwIC44OTItLjcyMyAxLjYxNS0xLjYxNSAxLjYxNWgtNy43NnoiLz4KICAgIDxwYXRoIHN0cm9rZT0iIzQ5NEU1MiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMTAuNTY2IDE4LjY2aC03Ljc2YTEuNjE1IDEuNjE1IDAgMCAxLTEuNjE2LTEuNjE1VjIuODA1YzAtLjg5Mi43MjMtMS42MTUgMS42MTUtMS42MTVoNy43NjFjLjg5MiAwIDEuNjE1LjcyMyAxLjYxNSAxLjYxNXYxNC4yNGMwIC44OTItLjcyMyAxLjYxNS0xLjYxNSAxLjYxNXoiLz4KICA8L2c+Cjwvc3ZnPgo="
        />
        <div className="feature__desc t2">All In One App</div>
      </div>
     </div>

    <div className="module">
      <div className="module__image">
        <Imgix
          src="https://brightsuite.imgix.net/overview/every-plan.png" //1
          width={624}
          height={624}
          imgixParams={{
            fit: "crop",
            crop: "focalpoint",
            "fp-x": 0.4,
            "fp-y": 0.6,
            // "fp-debug": true,
          }}
        />
      </div>
      <div className="module__content">
        <div className="module__header">Start with a strong foundation.</div>
        <div className="module__body t5">
        BrightSuite has everything you need to start building your smart home. All packages include motion sensors, window and door sensors, and a powerful control panel that acts as the brains of your smart home security system.
        </div>
        <div className="features">
          <div className="features__container">
            <div className="feature">
              <img
                className="feature__icon"
                src={touchscreen}
                alt="Touchscreen Panel"
              />
              <div className="t8">Touchscreen Hub</div>
            </div>
            <div className="feature">
              <img
                className="feature__icon"
                src={sensors}
                alt="Motion Sensors"
              />
              <div className="t8">Motion Sensors</div>
            </div>
            <div className="feature">
              <img
                className="feature__icon"
                src={windowSensors}
                alt="Window Sensors"
              />
              <div className="t8">Door/Window Sensors</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="module module--phone reverse">
      <div className="module__image">
        <Imgix
          src="https://brightsuite.imgix.net/overview/take-control.png" //2
          width={624}
          height={624}
          imgixParams={{ fit: "crop" }}
        />
      </div>
      <div className="module__content">
        <div className="module__header">
        Take control from here, there, or even way over there.
        </div>
        <div className="module__body t5">
        You're never too far from your smart home when you have the BrightSuite Application. Control your smart home security from anywhere using one single app.
        </div>
        <div className="features">
          <div className="features__container">
            <div className="feature">
              <img
                className="feature__icon"
                src={remote}
                alt="Remote Control"
              />
              <div className="t8">Remote Control</div>
            </div>
            <div className="feature">
              <img
                className="feature__icon"
                src={alerts}
                alt="Instant Alerts"
              />
              <div className="t8">Instant Alerts</div>
            </div>
            <div className="feature">
              <img
                className="feature__icon"
                src={codes}
                alt="Unique User Codes"
              />
              <div className="t8">Unique User Codes</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="module module--possible">
      <div className="module__image">
        <Imgix
          src="https://brightsuite.imgix.net/overview/add-products.png" //3
          width={624}
          height={624}
          imgixParams={{ fit: "crop" }}
        />
      </div>
      <div className="module__content">
        <div className="module__header">
          Open your home to a world of possibilites.
        </div>
        <div className="module__body t5">
        BrightSuite isn’t just hardware, it’s experiences. Set the lights to turn on when you hit the driveway, the door to unlock when you approach the porch, the music to start when you enter the kitchen. Configure it your way – the possibilities are endless.
        </div>
        <div className="features">
          <div className="features__container">
            <div className="feature">
              <img
                className="feature__icon"
                src={schedule}
                alt="Custom Schedules"
              />
              <div className="t8">Custom Schedules</div>
            </div>
            <div className="feature">
              <img
                className="feature__icon"
                src={location}
                alt="Location-Based Automation"
              />
              <div className="t8">Location-Based Automation</div>
            </div>
            <div className="feature">
              <img
                className="feature__icon"
                src={energy}
                alt="Effortless Energy Management"
              />
              <div className="t8">Effortless Energy Management</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <OverviewSellBlock
      showStarting
      body="Customize your options to create the product bundle that works for you."
      notes={["Professional Installation Available", "One-Time Hardware Cost"]}
      image="https://brightsuite.imgix.net/overview/build-your-bs.png"
      link="/popular"
    >
      Build your BrightSuite.

    </OverviewSellBlock>

    <Packages />
  </Layout>
)

export default OverviewPage
